export default __webpack_public_path__ + "static/media/mb.5cea0b6f.svg";